import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {}
}

const state = getDefaultState()

const mutations = {}

const actions = {
  async getPlanChangeDocuments({ commit }, params) {
    return await apiService.post(route('member.plan_change_document.get_documents'), params)
  },
  async savePlanChangeDocuments({ commit }, params) {
    const apiResult = await apiService.post(route('member.plan_change_document.save_documents'), params)
    if (apiResult) {
      return apiResult.data
    }
  },
  // 書類管理のエクセルを出力
  async exportDocuments({ commit }, params) {
    const apiResult = await apiService.post(route('member.plan_change_document.export_documents'), params)
    if (apiResult) {
      return apiResult
    }
  },
  // 書類管理のエクセルを保存
  async saveDocuments({ commit }, params) {
    const apiResult = await apiService.post(route('member.plan_change_document.save_documents'), params)
    if (apiResult) {
      return apiResult
    }
  },
  async getDocuments({ commit }, params) {
    const apiResult = await apiService.post(route('member.plan_change_document.get_documents'), params)
    if (apiResult) {
      return apiResult
    }
  },
  async write({ commit }, params) {
    const apiResult = await apiService.post(route('member.plan_change_document.write'), params)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async checkWriteStatus({ commit }, params) {
    const apiResult = await apiService.post(route('member.plan_change_document.check_write_status'), params)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async getProjectPlanningChangeAuthorizationsApplyPeriods({ commit }, params) {
    const apiResult = await apiService.post(
      route('member.monitoring_report_document.get_project_planning_change_authorizations_apply_periods'),
      params
    )
    return apiResult
  },
  async getCreditPersonChanges({ commit }, params) {
    const apiResult = await apiService.post(route('member.plan_change_document.get_credit_person_changes'), params)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async getProjectImplementChange({ commit }, params) {
    const apiResult = await apiService.post(route('member.plan_change_document.get_project_implement_change'), params)
    if (apiResult) {
      return apiResult
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
